import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-round-switch',
  templateUrl: './round-switch.component.html'
})
export class RoundSwitchComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  checkedOrNot = false;
  @Output() selectionChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  isSelected() {
    this.checkedOrNot = !this.checkedOrNot;
    this.selectionChanged.emit(this.checkedOrNot);
  }

}
